module.exports = __webpack_public_path__ + "static/media/card_brand_amex.cea4b648.svg";